import Headroom from 'headroom.js';
import DisclosureNav from "./_disclosureMenu.js";
export default class SiteHeader {
	constructor(node = '.site-header', opts = {}) {
		this.node = typeof node === 'string' ? document.querySelector( node ) : node;

		if ( ! this.node instanceof HTMLElement ) {
			return;
		}

		const siteheaderOverlapClass = this.node.classList.contains('site-header--overlaps-header') ? ' has-dark-background-color': '';

		this.opts = Object.assign(
			{
				headroom: {
					offset: 100,
					tolerance: {
						up: 7,
						down: 5
					},
					classes: {
						initial  : 'site-header',
						pinned   : 'site-header--pinned',
						unpinned : 'site-header--unpinned',
						top      : 'site-header--top' + siteheaderOverlapClass,
						notTop   : 'site-header--not-top',
						bottom   : 'site-header--bottom',
						notBottom: 'site-header--not-bottom',
						frozen   : 'site-header--frozen',
					},				
				},
				search: '.site-header__search',
				menu: '.site-header__menu',
				classes: {
					bodyOpened: "menu-fixed",
					searchActive: "site-header__utility-search--active",
					subMenuActive: "nav__menu-item--active",
					menuActive: "site-header__menu--active",
				}
			},
			
			opts
		);
		this.classes = this.opts.classes;
		if ( typeof this.opts.headroom === 'object' ) {
			// headroom
			this.headroom = new Headroom(this.node, this.opts.headroom);
			this.headroom.init();
			this.headroom.update(this.headroom);
		}

		
		//flyout button triggers
		this.search    = typeof this.opts.search === 'string' ? this.node.querySelector(this.opts.search) : this.opts.search;
		this.hamburger = typeof this.opts.menu   === 'string' ? this.node.querySelector(this.opts.menu)   : this.opts.menu;

		//desktop search trigger
		this.searchBtn = this.node.querySelectorAll(".site-header__utility-search-btn");

		this.searchBtn.forEach((search) => {
			search.addEventListener("click", () => {
				if (this.node.classList.contains(this.classes.searchActive)) {
					closeSearch();
				} else {
					openSearch();
				}
			});
		});

		//search functions
		const openSearch = () => {

			this.node.classList.add(this.classes.searchActive);
			this.node.querySelector(".searchform__input").focus();
		};

		const closeSearch = () => {
			this.node.classList.remove(this.classes.searchActive);
		};

		//submenus
		var menus = document.querySelectorAll('.nav--primary .wp-block-navigation');
		var disclosureMenus = [];

		for (var i = 0; i < menus.length; i++) {
			disclosureMenus[i] = new DisclosureNav(menus[i]);
		}


		this.isGreater992 = document.body.clientWidth >= 992;
		let matchMedia = window.matchMedia("(min-width: 992px)");
		matchMedia.addEventListener("change", () => {
			this.isGreater992 = document.body.clientWidth >= 992;
		});


	}


}
// if mobile and switch to 992, and nav was open, need to remove fixed body class, remove nav--opened class, remove nav__content--opened

